import * as React from "react";

export default () => {
  return <div>Ange vilka fordonsplatser avtalet gället för.</div>;
};
